import operations from './operations';
import download from './operations/download';

const path = '/logs';

const logs = (url: string) => () => ({
  operations: operations(url + path),
});

export default logs;